/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

import * as React from "react";
import { createUseScreenVariants } from "@plasmicapp/react-web";

export type TmpValue = "override";
export const TmpContext = React.createContext<TmpValue | undefined>(
  "PLEASE_RENDER_INSIDE_PROVIDER" as any
);
export function TmpContextProvider(
  props: React.PropsWithChildren<{ value: TmpValue | undefined }>
) {
  return (
    <TmpContext.Provider value={props.value}>
      {props.children}
    </TmpContext.Provider>
  );
}

export function useTmp() {
  return React.useContext(TmpContext);
}

export default TmpContext;
/* prettier-ignore-end */
